var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.272 631.008v181.412c0 21.246 25.112 32.541 41.040 18.459l382.886-338.513c11.203-9.904 11.077-27.406-0.266-37.15l-382.886-328.887c-16.002-13.745-40.774-2.39-40.774 18.691v218.438c-183.252 66.163-429.163 28.168-482.36-122.075-9.403-26.557-48.853-19.133-47.937 9.020 6.419 197.223 91.403 315.714 233.539 365.297 90.274 31.491 193.665 32.677 296.758 15.308zM620.968 755.2v-154.644c0-15.414-14.31-26.962-29.62-23.903-105.001 20.979-211.704 22.706-300.684-7.959-96.757-33.345-162.076-102.111-188.264-215.448 47.938 45.171 116.112 73.079 198.181 84.304 102.948 14.080 222.687-0.314 304.892-32.928 9.362-3.714 15.495-12.671 15.495-22.627v-179.755l321.112 272.492-321.112 280.468z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrow);
export default __webpack_public_path__ + "static/media/share-arrow.19123ee84546c4cede4f9592b50478d9.svg";
export { ForwardRef as ReactComponent };